export const ItemTypes = {
    TILE: 'tile'
}
